import React, { createContext, useState, useEffect, useContext } from 'react'
import cookie from 'react-cookies'
import CookiesModal from '../../components/CookiesModal'
import { LanguageContext } from '../language/languageState'
import '../../styles/Cookies.scss'

const WECAR_COOKIE_CONSENT_KEY = "wecar_cookie_consent"

const CookiesContext = createContext()

const CookiesState = ({ children }) => {

  const { t, localizedDocumentUrl } = useContext(LanguageContext)

  const [cookiesChanged, setCookiesChanged] = useState(false)
  const [showCookies, setShowCookies] = useState(false)
  const [analytics, setAnalytics] = useState(false)
  const [screenSize, setScreenSize] = useState(null)
  const [showMore, setShowMore] = useState(false)
  const [showPreferences, setShowPreferences] = useState(false)

  // On cookies update
  useEffect(() => {
    if (cookiesChanged) {
      setShowCookies(false)
    }
  }, [cookiesChanged])

  useEffect(() => {
    setShowCookies(!isCookieAccepted())
  }, [])

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth)
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Save cookie
  const acceptCookies = (obj) => {
    const expires = new Date(Date.now() + 1000 * 60 * 60 * 24 * 730) // expire in 2 years
    cookie.save(
      WECAR_COOKIE_CONSENT_KEY, 
      JSON.stringify(obj), 
      { 
        path: '/', 
        expires: expires
      }
    )
    setCookiesChanged(true)
  }

  // Check if cookie exist
  const isCookieAccepted = () => {
    return cookie.load(WECAR_COOKIE_CONSENT_KEY)
  }


  const saveCookies = (type = '') => {
    let obj
    switch (type) {
      case 'all':
        obj = { required: true, tracking: true }
        break
      case 'necessary':
        obj = { required: true, tracking: false }
        break
      case '':
        obj = { required: true, tracking: analytics }
        break
      default:
        obj = { required: true, tracking: analytics }
    }

    acceptCookies(obj)
  }

  return (
    <CookiesContext.Provider value={{}}>
      {showCookies && <div className="cookies-section-wrapper">
        <div className="landing-container">
          <div className="cookies-section">
            <img src="/cookie.webp" alt="cookie" className="cookies-section__cookie" width={60} height={60} />
            <div className="cookies-section__top">
              <p>{t('cookies.intro_1')}</p>
              <p>{t('cookies.intro_2')}</p>
            </div>
            <div className="cookies-section__actions">
              <button medium onClick={() => saveCookies('all')}>{t('cookies.toggle_1')}</button>
              {(screenSize > 1024 || showMore) && <>
                <button className='light' onClick={() => saveCookies('necessary')}>{t('cookies.toggle_2')}</button>
                <button className='light' onClick={() => setShowPreferences(true)}>{t('cookies.toggle_3')}</button>
              </>}
              {screenSize < 1024 && !showMore  && <button className='blue' onClick={() => setShowMore(true)}>{t('cookies.more')}</button>}
              {screenSize < 1024 && showMore  && <button className='blue' onClick={() => setShowMore(false)}>{t('cookies.less')}</button>}
            </div>
            {(screenSize > 1024 || showMore) && <div className="cookies-section__bottom">
              <p>
                {t('cookies.detail_text')}&nbsp;
                <a href={localizedDocumentUrl('cookies')} className="link" target="_blank" rel="noreferrer">{t('cookies.detail_text_1')}</a>
              </p>
            </div>}
            <CookiesModal showModal={showPreferences} onClose={() => setShowPreferences(false)} onAccept={acceptCookies} />
          </div>
        </div>
      </div>}
      {children}
    </CookiesContext.Provider>
  )
}

export default CookiesState
export { CookiesContext }